import { checkDomainAllowFetchDataConfig } from 'components/common/func';
import jwtDecode from 'jwt-decode';
import { useEffect } from 'react';
import { SET_OPEN_REFRESH_TOKEN_POPUP } from 'store/action';
import useAuth from './useAuth';
import useStore from './useStore';

const useRefreshTokenTrigger = () => {
  const { state, dispatch } = useStore();
  const { isRefreshToken } = state || {};
  const { token } = useAuth();

  useEffect(() => {
    if (!checkDomainAllowFetchDataConfig()) return;
    if (token) {
      const { exp } = jwtDecode(token);

      const listener = () => {
        if (Date.now() >= (exp - 120) * 1000) {
          !isRefreshToken &&
            dispatch({ type: SET_OPEN_REFRESH_TOKEN_POPUP, payload: true });
        }
      };
      document.addEventListener('mousedown', listener);
      document.addEventListener('touchstart', listener);
      return () => {
        document.removeEventListener('mousedown', listener);
        document.removeEventListener('touchstart', listener);
      };
    }
  }, [token, isRefreshToken]);
};

export default useRefreshTokenTrigger;
